document.addEventListener("DOMContentLoaded", function() {
    const carousel = document.querySelector('.product-carousel');
    const items = carousel.querySelectorAll('.product-item');
    const leftArrow = document.querySelector('.left-arrow');
    const rightArrow = document.querySelector('.right-arrow');

    // Scroll left by one item
    function scrollLeft() {
      carousel.scrollBy({
        left: -items[0].offsetWidth,  // Adjusted: Removed margin offset
        behavior: 'smooth'
      });
    }

    // Scroll right by one item
    function scrollRight() {
      carousel.scrollBy({
        left: items[0].offsetWidth,  // Adjusted: Removed margin offset
        behavior: 'smooth'
      });
    }

    // Handle arrow clicks
    leftArrow.addEventListener('click', scrollLeft);
    rightArrow.addEventListener('click', scrollRight);

    // Handle mouse wheel scrolling (horizontal scroll)
    carousel.addEventListener('wheel', function(event) {
      if (event.deltaY !== 0) {
        event.preventDefault(); // Prevent vertical scroll
        carousel.scrollBy({
          left: event.deltaY > 0 ? items[0].offsetWidth : -items[0].offsetWidth,  // Adjusted: Removed margin offset
          behavior: 'smooth'
        });
      }
    });
});
